import { render, staticRenderFns } from "./test.vue?vue&type=template&id=c8e11c48&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"
import style0 from "./test.vue?vue&type=style&index=0&id=c8e11c48&prod&lang=scss&scoped=true"
import style1 from "./test.vue?vue&type=style&index=1&id=c8e11c48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e11c48",
  null
  
)

export default component.exports